import * as types from '../mutation-types'
import api from '@/api/engagements'

// initial state
const state = {
    engagements: [],
    loaded: false,
    engagementProjects: [],
    engagementKeyFacts: [],
    selectedEngagement: {},
    engagementProjectsLoaded: false,
}

const getters = {
    engagements: state => state.engagements,
    engagementsLoaded: state => state.loaded,
    engagementProjects: state => state.engagementProjects,
    engagementKeyFacts: state => state.engagementKeyFacts,
    selectedEngagement: state => state.selectedEngagement,
    engagementProjectsLoaded: state => state.engagementProjectsLoaded,
}

const actions = {
    getEngagements({ commit }) {
        commit(types.SET_ENGAGEMENTS_LOADED, false );
        api.getEngagements((response) => {
            commit(types.SET_ENGAGEMENTS, response._embedded.Engagement );
            commit(types.SET_ENGAGEMENTS_LOADED, true );
        })
    },
    setSelectedEngagement({ commit }, engagement) {
        commit(types.SET_ENGAGEMENT, engagement );
    },
    getEngagementProject({ commit }, payload) {
        commit(types.SET_ENGAGEMENTS_PROJECTS_LOADED, false );
        api.getEngagementProject(payload, (response) => {
            commit(types.SET_ENGAGEMENT_PROJECTS, response._embedded.EngagementProject );
            commit(types.SET_ENGAGEMENTS_PROJECTS_LOADED, true );
        })
    },
    getEngagementKeyFacts({ commit }, payload) {
        api.getEngagementKeyFact(payload, (response) => {
            commit(types.SET_ENGAGEMENT_KEY_FACTS, response._embedded.EngagementKeyFact );
        })
    },
    cleanEngagements({commit}) {
        commit(types.SET_ENGAGEMENTS_LOADED, false );
        commit(types.SET_ENGAGEMENTS, {} );
    }
}

const mutations = {
    [types.SET_ENGAGEMENTS] (state, engagements ) {
        state.engagements = engagements
    },
    [types.SET_ENGAGEMENT] (state, engagement ) {
        state.selectedEngagement = engagement
    },
    [types.SET_ENGAGEMENTS_LOADED] (state, status ) {
        state.loaded = status
    },
    [types.SET_ENGAGEMENT_PROJECTS] (state, projects ) {
        state.engagementProjects = projects
    },
    [types.SET_ENGAGEMENTS_PROJECTS_LOADED] (state, status ) {
        state.engagementProjectsLoaded = status
    },
    [types.SET_ENGAGEMENT_KEY_FACTS] (state, keyFacts ) {
        state.engagementKeyFacts = keyFacts
    },
}


export default {
    state,
    getters,
    actions,
    mutations
}


